<template>
  <div class="modal fade" id="almacenModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <span v-if="isEditing && almacen?.descripcion">Editar Almacén: {{ almacen.descripcion }}</span>
            <span v-else>Agregar Nuevo Almacén</span>
          </h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="submitForm">
            
            <div class="form-group">
              <label>Código Identificador</label>
              <input v-model="form.codigo" type="text" 
                class="form-control text-uppercase" 
                :class="{'is-invalid': errors.codigo}"
                placeholder="Ej: ALM-001" 
                :disabled="isEditing" />
              <div class="invalid-feedback">{{ errors.codigo }}</div>
              <small v-if="!isEditing" class="text-muted">Máximo 20 caracteres. No podrá cambiarse después.</small>
            </div>

            <div class="form-group">
              <label>Nombre / Descripción del Almacén</label>
              <input v-model="form.descripcion" type="text" 
                class="form-control text-uppercase" 
                :class="{'is-invalid': errors.descripcion}"
                placeholder="Ej: ALMACÉN PRINCIPAL PUERTO LA CRUZ" />
              <div class="invalid-feedback">{{ errors.descripcion }}</div>
            </div>

            <div class="form-group">
              <label>Empresa Propietaria</label>
              <select 
                v-model="form.empresa_id" 
                class="form-control" 
                :class="{'is-invalid': errors.empresa_id}"
                :disabled="isEditing">
                <option value="" disabled>Seleccione una empresa</option>
                <option v-for="empresa in empresas" :key="empresa.id" :value="empresa.id">
                  {{ empresa.nombre }}
                </option>
              </select>
              <div class="invalid-feedback">{{ errors.empresa_id }}</div>
            </div>

            <div v-if="isEditing" class="form-group">
                <label>Estatus del Almacén</label>
                <div class="custom-control custom-switch">
                    <input type="checkbox" v-model="form.estatus" class="custom-control-input" id="switchAlm">
                    <label class="custom-control-label" for="switchAlm">
                        {{ form.estatus ? 'ACTIVO (Disponible para movimientos)' : 'INACTIVO (Bloqueado)' }}
                    </label>
                </div>
                <small class="text-info" v-if="almacen?.estatus && !form.estatus">
                    <i class="fas fa-info-circle"></i> Al desactivar, el sistema validará que el stock actual sea cero.
                </small>
            </div>

            <div class="modal-footer px-0 pb-0 mt-4">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                <button type="submit" class="btn btn-primary">
                    {{ isEditing ? "Actualizar Datos" : "Registrar Almacén" }}
                </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import { loading } from '@/plugins/loading';
import { alert } from '@/plugins/alert';

export default {
    props: ['almacen', 'empresas'],
    data() {
        return {
            form: this.getDefaultForm(),
            errors: {}
        };
    },
    computed: {
        isEditing() { 
            return !!(this.almacen && this.almacen.id); 
        },
    },
    watch: {
        almacen: {
            immediate: true,
            handler(newVal) {
                this.errors = {};
                if (newVal && newVal.id) {
                    this.form = { 
                        ...newVal,
                        estatus: Boolean(newVal.estatus) 
                    };
                } else {
                    this.form = this.getDefaultForm();
                }
            }
        },
    },
    methods: {
        getDefaultForm() {
            return { codigo: "", descripcion: "", empresa_id: '', estatus: true };
        },
        async submitForm() {
            this.errors = {};
            
            // Validaciones de Frontend
            if (!(this.form.codigo || "").trim()) this.errors.codigo = "El código es obligatorio.";
            if (!(this.form.descripcion || "").trim()) this.errors.descripcion = "La descripción es necesaria.";
            if (!this.form.empresa_id) this.errors.empresa_id = "Debe asignar el almacén a una empresa.";

            if (Object.keys(this.errors).length > 0) {
                return alert.toast({ title: 'Completa los campos requeridos', icon: 'warning' });
            }

            try {
                loading.show('Procesando almacén...');

                const payload = {
                    nombre: this.form.descripcion.trim().toUpperCase(), // Sincronizado con BD si el modelo usa 'nombre'
                    descripcion: this.form.descripcion.trim().toUpperCase(),
                    codigo: this.form.codigo.trim().toUpperCase(),
                    empresa_id: this.form.empresa_id,
                    estatus: this.form.estatus
                };

                if (this.isEditing) {
                    await api.put(`/almacen/${this.almacen.id}`, payload);
                } else {
                    await api.post("/almacen", payload);
                }

                loading.hide();
                alert.toast({ title: '¡Almacén guardado!', icon: 'success' });
                this.$emit("success");
                this.form = this.getDefaultForm();
                $("#almacenModal").modal("hide");

            } catch (error) {
                loading.hide();
                console.error("Error:", error);
                
                // Captura de errores de lógica del backend (422 Stock > 0)
                const errorMsg = error.response?.data?.message || 'Error al procesar la solicitud.';
                alert.toast({ title: errorMsg, icon: 'error', timer: 5000 });

                if (error.response?.status === 422) {
                    this.errors = error.response.data.errors || {};
                }
            }
        },
    },
};
</script>